import React from 'react';
import styled from '@emotion/styled';
import { tokens } from '@onward-delivery/design/tokens';
import { DESIGN_SCOPE_CLASS } from '@onward-delivery/design/scope';

import * as typography from '@/styles/typography';

import { FILL_STATES, fillState } from './dayMetrics';

export const local = {
    greys: ['#0C0B1D'],
};

// Design utilities are emitted as `.onward-design .x`, so the class has to sit on an ancestor;
// `display: contents` keeps it out of the layout without breaking descendant selectors.
//
// ⚠️ Preflight resets `border-width: 0` on every descendant and wins the specificity tie against
// MUI's JSS, so don't wrap MUI bordered controls (outlined TextField, Select) in this.
const ScopeBox = styled.div`
    display: contents;
`;

export const DesignScope = ({ children }) => <ScopeBox className={DESIGN_SCOPE_CLASS}>{children}</ScopeBox>;

// Hex rather than var(--color-*): the tinted treatments below do alpha math on the value, and
// `var(--color-warning)1f` is not a colour.
export const TOKENS = Object.fromEntries(Object.entries(tokens.color).map(([name, scale]) => [name, scale.DEFAULT]));

export const BORDER = TOKENS.border;
export const GREY_TEXT = TOKENS.muted;

// Shared with the resource dialog's bars so the two can't drift. UNCONFIGURED has no entry —
// fillState() never returns it, and callers branch on that state before they reach a colour.
export const FILL_COLORS = {
    [FILL_STATES.AVAILABLE]: TOKENS.primary,
    [FILL_STATES.NEAR]: TOKENS.warning,
    [FILL_STATES.FULL]: TOKENS.destructive,
};

export const FILL_LABELS = {
    [FILL_STATES.AVAILABLE]: 'Available',
    [FILL_STATES.NEAR]: 'Near cap',
    [FILL_STATES.FULL]: 'Full',
};

export const fillColor = (percent) => FILL_COLORS[fillState(percent)];

export const SectionHeader = styled.div`
    ${typography.sansSerif}

    font-size: 16px;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #2b2b2b;
    margin-bottom: 12px;
`;

export const SectionSubheader = styled.div`
    ${typography.sansSerif}

    font-size: 12px;
    font-weight: 400;
    color: ${GREY_TEXT};
    margin: -8px 0 12px;
`;

// Unused on this page now, but Claims' EditClaimModal still imports it from here.
export const HR = styled.div`
    width: 100%;
    margin-top: 32px;
    margin-bottom: 32px;
    border: 1px solid rgba(76, 76, 76, 0.5);
`;

export const PageTitle = styled.span`
    ${typography.sansSerif}
    font-size: 28px;
    font-weight: 800;
    line-height: 34px;
`;

export const Header1 = styled.span`
    ${typography.sansSerif}
    font-size: 22px;
    font-weight: 800;
    line-height: 27px;
`;

export const Header2 = styled.span`
    ${typography.sansSerif}
    font-size: 20px;
    font-weight: 900;
    line-height: 25px;
`;

export const Body1 = styled.span`
    ${typography.sansSerif}
    font-size: 14px;
    font-weight: 800;
    line-height: 20px;
`;

export const Body2 = styled.span`
    ${typography.sansSerif}
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
`;
